import './TicketFooter.less';

import React from 'react';
import i18n from '@i18n';
import TicketStatus from '@/mytickets/constants/ticketStatus';
import WinningMethod from '@/mytickets/constants/winnigMethod';
import { dateTime } from '@/mytickets/utils';
import ExtrasNg from './Extras/ExtrasNg';
import StakeDetailNg from './StakeDetailNg';

function getTiketWinningMethodStatus(method) {
    switch (method) {
        case WinningMethod.Cashin:
            return i18n('ticketus.ticket.status.wm.Cashin');
        case WinningMethod.CancelledBet:
        case WinningMethod.ReturnedBet:
            return i18n('ticketus.ticket.status.wm.Returned');
        default:
            return null;
    }
}

function getTiketDisplayStatus(status, winningMethod, saved) {
    if (saved) return i18n('ticketus.ticket.status.Saved');

    switch (status) {
        case TicketStatus.Registered:
            return i18n('ticketus.ticket.status.Registered');
        case TicketStatus.Lost:
            return i18n('ticketus.ticket.status.Lost');
        case TicketStatus.Won:
            return getTiketWinningMethodStatus(winningMethod) || i18n('ticketus.ticket.status.Won');
        case TicketStatus.PaidOut:
            return getTiketWinningMethodStatus(winningMethod) || i18n('ticketus.ticket.status.PaidOut');
        case TicketStatus.Cancelled:
            return i18n('ticketus.ticket.status.Cancelled');
        default:
            return i18n('-'); // nemoze nastat (snad)
    }
}

function PaidOutRow({ paidOutDate, state }) {
    let ret = null;
    if (state === TicketStatus.Lost) {
    } else if (state === TicketStatus.PaidOut || state === TicketStatus.Cancelled) {
        const rowInfo = `${dateTime(paidOutDate, 'DD.MM.YYYY')} ${dateTime(paidOutDate, 'HH:mm:ss')}`;
        ret = <TicketFooterRow rowTitle="ticketus.ticketPaidOutDate" rowInfo={rowInfo} />;
    } else {
        ret = <TicketFooterRow rowTitle={''} rowInfo={i18n('ticketus.ticket.vyplatenie.nevyplatenyTiket')} />;
    }
    return ret;
}

export function TicketFooterRow({ rowTitle, rowInfo }) {
    return (
        <div className="ticket-detail-footer-row">
            {rowTitle && <span className="ticket-detail-footer-row-left">{i18n(rowTitle)}</span>}
            <span className="ticket-detail-footer-row-right">{rowInfo}</span>
        </div>
    );
}

function platformText(ticket) {
    const platform = ticket.get('platform');
    let ret = i18n('jsp.detailTiketu.sposobPodania.online');
    if (platform) {
        if (platform === 'Branch') {
            ret = i18n('jsp.detailTiketu.sposobPodania.branch');
        } else if (platform === 'Sms') {
            ret = i18n('jsp.detailTiketu.sposobPodania.sms');
        }
    }
    return ret;
}

function savedPlatformText(ticket) {
    const platform = ticket.get('platform');
    let ret = i18n('jsp.detailTiketu.sposobUlozenia.portal');
    if (platform && platform === 'Mobile') {
        ret = i18n('bonus.steps.ticketName.Mobil');
    }
    return ret;
}

function TicketFooter({ ticket, status, winningMethod, cashinClosingModeActive }) {
    const saved = ticket.get('source') === 'Saved';
    const displayStatus = getTiketDisplayStatus(status, winningMethod, saved);
    const number = saved ? ticket.get('ticketNoVisual') : ticket.get('ticketNumber');
    const submitDate = ticket.get('submitDate');
    const platform = platformText(ticket);
    const savedPlatform = saved && savedPlatformText(ticket);
    const paidOutDate = ticket.get('paidOutDate');

    return (
        <div className="ticket-detail-footer">
            <div className="ticket-detail-footer-ticket-state">
                {displayStatus + ' ' + i18n('jsp.kurzovaPonuka.Tiket')}
            </div>
            {saved && (
                <TicketFooterRow
                    rowTitle={i18n('ticketus.status')}
                    rowInfo={
                        status === TicketStatus.Registered
                            ? i18n('ticketus.ticket.unevaluated')
                            : i18n('ticketus.ticket.evaluated')
                    }
                />
            )}
            <TicketFooterRow rowTitle={i18n('ticketus.ticketNumber')} rowInfo={number} />
            <TicketFooterRow
                rowTitle={saved ? i18n('ticketus.ticketDateTime.saved') : i18n('ticketus.ticketDateTime.placed')}
                rowInfo={dateTime(submitDate, 'DD.MM.YYYY') + ' ' + dateTime(submitDate, 'HH:mm:ss')}
            />
            <TicketFooterRow
                rowTitle={i18n('ticketus.ticket.betType')}
                rowInfo={i18n(`ticketus.ticket.bettype.${ticket.get('betType')}`)}
            />
            {saved ? (
                <TicketFooterRow rowTitle={i18n('jsp.detailTiketu.sposobUlozenia')} rowInfo={savedPlatform} />
            ) : (
                <TicketFooterRow rowTitle={i18n('jsp.detailTiketu.sposobPodania')} rowInfo={platform} />
            )}
            {!saved && <PaidOutRow paidOutDate={paidOutDate} state={status} />}
            {ticket.get('megaBet') ? (
                <TicketFooterRow rowTitle={''} rowInfo={i18n('ticketus.ticket.extras.megaStake')} />
            ) : null}
            {ticket.get('displayStatus') === 'CashinPaidOut' && ticket.get('automaticCashin') ? (
                <TicketFooterRow
                    rowTitle={i18n('ticketus.ticket.paiOutMethod')}
                    rowInfo={i18n('ticketus.ticket.paiOutMethod.automatic')}
                />
            ) : null}

            <ExtrasNg ticket={ticket} cashinClosingModeActive={cashinClosingModeActive} />
            <StakeDetailNg spent={ticket.get('spent')} saved={saved} fees={ticket.get('fees')} />
            {saved && <TicketFooterRow rowInfo={i18n('saved.tickets.warning')} />}
        </div>
    );
}

export default TicketFooter;
